import { render, staticRenderFns } from "./ProjectDeclaration.vue?vue&type=template&id=05378905&scoped=true&"
import script from "./ProjectDeclaration.vue?vue&type=script&lang=js&"
export * from "./ProjectDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDeclaration.vue?vue&type=style&index=0&id=05378905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05378905",
  null
  
)

export default component.exports